const VIDEO_EXP = /^video\//i

export function isVideoAsset(mimeType){
  return VIDEO_EXP.test(mimeType)
}

const IMAGE_EXP = /^image\//i

export function isImageAsset(mimeType){
  return IMAGE_EXP.test(mimeType)
}



// WEBPACK FOOTER //
// ./src/app/util/file.js